import { Button, em, rem, ButtonProps } from '@innovyze/stylovyze';
import { CircularProgress } from '@mui/material';
import React, { ReactElement } from 'react';
import styled from 'styled-components';

const ButtonWrapper = styled.div`
	display: inline-flex;
`;

export const ActionButton = styled(Button)`
	margin-left: ${em(10)};
	box-shadow: 0 0 0 0;
	&& .MuiButton-label {
		display: inline-grid;
		/* grid-template-columns: 1fr 2rem; */
		grid-template-columns: auto auto;
		grid-gap: ${rem(15)};
	}
`;

export const PageHeader = styled('div')`
	font-size: 14pt;
	font-weight: 500;
	padding: 10px 0px 10px 0px;
`;

interface Props extends ButtonProps {
	children: string;
	loading?: boolean;
}

export default function LoadingButton({
	children,
	loading,
	...props
}: Props): ReactElement {
	return (
		<ButtonWrapper>
			<ActionButton {...props} variant="contained">
				<div>{children}</div>
				{loading && (
					<CircularProgress
						style={{
							width: '1.5rem',
							height: '1.5rem',
							display: 'block',
						}}
					/>
				)}
			</ActionButton>
		</ButtonWrapper>
	);
}
